module.exports = __webpack_public_path__ + "static/media/storefront_selected.00944e4b.svg";